module.exports = __webpack_public_path__ + "img/ch16_22_钳制机械臂.c7c0dc7c.jpg";